import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shopping-bag-2"} maskId="square-filled-radius-0-stroke-1-IconShoppingBag2"><path fillRule="evenodd" clipRule="evenodd" d="M7.99835 6C7.99835 3.79086 9.78921 2 11.9984 2C14.2075 2 15.9984 3.79086 15.9984 6V7H18.432L20.5749 22H3.42188L5.56473 7H7.99835V6ZM8.99835 7H14.9984V6C14.9984 4.34315 13.6552 3 11.9984 3C10.3415 3 8.99835 4.34315 8.99835 6V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShoppingBag2;
